<template>
  <div>
    <b-row v-for="(item, itemIndex) in items" :key="itemIndex" class="mb-1 text-center">
      <b-col>
        <b-form-select v-model="item.condition" :options="conditions" :disabled="readonly"/>
      </b-col>
      <b-col>
        <b-form-select v-model="item.dimension" :options="dimensions" text-field="label" value-field="dimension"
                       :disabled="readonly" @change="dimensionChanged(item.dimension, itemIndex)"/>
      </b-col>
      <b-col>
        <fa icon="spinner" v-if="loading.includes(itemIndex)" class="mt-2"></fa>
        <b-form-select v-else v-model="item.value" :options="filteredValues[itemIndex]" :select-size="1" :disabled="readonly"></b-form-select>
      </b-col>
      <b-col cols="1">
        <b-btn size="sm" class="mr-1 mt-1" :disabled="items.length <= 1"  v-if="!readonly">
          <fa icon="times" @click="removeItem(itemIndex)"/>
        </b-btn>
        <b-btn size="sm" class="mt-1" v-if="!readonly">
          <fa icon="plus" @click.prevent="addItem"/>
        </b-btn>
      </b-col>
    </b-row>

    <div class="d-flex">
      <b-btn @click.prevent="searchCustomers" v-if="!readonly">{{$t('sandoz.search_customers')}}</b-btn>
      <div class="ml-auto">
        {{rightText}}
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    data: () => ({
      conditions: [],
      items: [],
      dimensionValues: [],
      filteredValues: [],
      loading: []
    }),
    props: {
      value: {
        default: null,
        type: Array
      },
      dimensions: {
        type: Array
      },
      url: {
        type: String
      },
      readonly: {
        type: Boolean,
        default: false
      },
      rightText: {
        type: String
      }
    },
    mounted() {
      this.items = this.value ? this.value : []
      if (this.items.length == 0) {
        this.addItem()
      }
      this.loadDimensionValues()
      this.conditions.push({
        value: 'include',
        text: this.$i18n.t('sandoz.include')
      })
      this.conditions.push({
        value: 'exclude',
        text: this.$i18n.t('sandoz.exclude')
      })
    },

    watch: {
      value(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.items = newVal
        }
      },
      items(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('input', newVal)
        }
      }
    },
    methods: {
      removeItem(itemIndex) {
        if (this.items.length <= 1) {
          return
        }
        this.items.splice(itemIndex, 1)
      },
      addItem() {
        this.items.push({
          condition: 'include',
          dimension: '',
          value: ''
        })
      },
      loadDimensionValues() {
        var _self = this
        axios.get(_self.url).then(response => {
          _self.dimensionValues = response.data
          _self.items.forEach(function (item, itemIndex) {
            _self.dimensionChanged(item.dimension, itemIndex)
          })
        })
      },
      searchCustomers() {
        this.$emit('search-customers', this.items)
      },
      dimensionChanged (dimension, index) {
        var _self = this
        _self.loading.push(index)
        setTimeout(function () {
          _self.filteredValues[index] = _self.dimensionValues[dimension] ? _self.dimensionValues[dimension] : []
          const loadingIndex = _self.loading.indexOf(index)
          _self.loading.splice(loadingIndex, 1)
        }, 1)
      }
    }
  }
</script>
